import script from "./monitoring-page.vue?vue&type=script&setup=true&lang=js"
export * from "./monitoring-page.vue?vue&type=script&setup=true&lang=js"

import "../assets/style/styles.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__